function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.292969 1.292969 C 9.480469 1.105469 9.734375 1 10 1 L 18 1 C 19.65625 1 21 2.34375 21 4 L 21 7 C 21 7.550781 20.550781 8 20 8 C 19.449219 8 19 7.550781 19 7 L 19 4 C 19 3.449219 18.550781 3 18 3 L 11 3 L 11 8 C 11 8.550781 10.550781 9 10 9 L 5 9 L 5 20 C 5 20.550781 5.449219 21 6 21 L 11 21 C 11.550781 21 12 21.449219 12 22 C 12 22.550781 11.550781 23 11 23 L 6 23 C 4.34375 23 3 21.65625 3 20 L 3 8 C 3 7.734375 3.105469 7.480469 3.292969 7.292969 Z M 6.414062 7 L 9 7 L 9 4.414062 Z M 18.25 20.75 C 18.25 21.441406 17.691406 22 17 22 C 16.308594 22 15.75 21.441406 15.75 20.75 C 15.75 20.058594 16.308594 19.5 17 19.5 C 17.691406 19.5 18.25 20.058594 18.25 20.75 Z M 15.136719 12.964844 C 15.398438 12.460938 16.082031 12 17 12 C 18.28125 12 19 12.835938 19 13.5 C 19 14.164062 18.28125 15 17 15 C 16.449219 15 16 15.449219 16 16 L 16 17 C 16 17.550781 16.449219 18 17 18 C 17.550781 18 18 17.550781 18 17 L 18 16.886719 C 19.632812 16.511719 21 15.246094 21 13.5 C 21 11.402344 19.03125 10 17 10 C 15.457031 10 14.023438 10.773438 13.363281 12.035156 C 13.109375 12.523438 13.296875 13.128906 13.785156 13.386719 C 14.273438 13.640625 14.878906 13.453125 15.136719 12.964844 Z M 15.136719 12.964844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.1ef3772cb0bc6edf5ebec364ff6343ca.svg";
export { ForwardRef as ReactComponent };